import React from 'react';
import { Pie } from 'react-chartjs-2';

const PieChart = ({ data }) => {
	if (data) {
		return (
			<Pie
				data={data}
				options={{
					plugins: {
						legend: {
							display: false
						}
					},
					responsive: true
				}}
				type={'pie'}
			/>
		);
	} else {
		return '';
	}
};

export default PieChart;
